import LoginPasswordType from "@/views/Login/login-password-type.vue";
import Agreenment from "@/components/Agreenment/agreenment.vue";
import { emailVerificationCode } from "@/service/user";
import { onInputRange } from "@/utils/util.js";
export default {
  name: "login-main-email",
  components: {
    LoginPasswordType,
    Agreenment
  },
  props: {
    login: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      onInputRange,
      passwordType: {
        type: "password",
        // 验证方式
        password: "",
        // 密码
        verificationCode: "" // 验证码
      },
      rules: {
        email: [{
          required: true,
          message: $t("irio214", "邮箱必填"),
          trigger: "blur"
        }, {
          pattern: /.*@\w+([-.]\w+)*\.\w+([-.]\w+)*/,
          message: $t("venleq7", "邮箱格式不正确"),
          trigger: "blur"
        }]
      }
    };
  },
  methods: {
    onChange(val) {
      this.passwordType = {
        ...this.passwordType,
        ...val
      };
    },
    handleContinue() {
      if (this.passwordType.type === "password") {
        this.$refs["formEmail"].validate(valid => {
          if (valid) {
            this.handleContinuePassword();
          }
        });
      } else {
        this.handleContinueCode();
      }
    },
    /**
     * 验证码验证成功，发送验证码
     */
    async handleSuccessVerify(value, startResentTimeFn) {
      const res = await emailVerificationCode(this.login.formData.email, value.captchaVerification, "LOGIN");
      if (res.data && res.data.result === 0) {
        this.$Message.success($t("px9tpm6", "验证码已发送"));
        // 验证码发送成功，开始倒计时
        startResentTimeFn();
      } else if (res.data.result === 10012) {
        //抛出异常
        this.$emit("no-mobile-email");
      }
    },
    /**
     * 密码登录
     */
    handleContinuePassword() {
      let validate = this.$refs["loginPasswordTypeEmail"].validPassword();
      validate(valid => {
        if (valid) {
          const data = {
            accountType: this.login.loginType,
            password: this.passwordType.password,
            mobile: this.login.formData.email
          };
          this.$emit("on-continue-password", data);
        }
      });
    },
    /*
     * 验证码登录
     */
    handleContinueCode() {
      let validate = this.$refs["loginPasswordTypeEmail"].validCode();
      validate(valid => {
        if (valid) {
          this.$emit("on-continue-code", {
            email: this.login.formData.email,
            verificationCode: this.passwordType.verificationCode
          });
        }
      });
    }
  }
};